import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { Employee, EmployeeGroupe } from 'src/app/_interfaces/Employee';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { HttpService } from 'src/app/_provider/http.service';
import { SaveService } from 'src/app/_provider/save.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { PopoverListItem, PopoverPage } from 'src/app/_template/popover/popover.page';

export enum CustomerLoginMailSendState{
  OFF = 1,
  REQUEST = 2,
  ALWAYS = 3,
}

export interface CustomerLogin{
  employees: number[],
  selectedGroup: number,
  ticketArt: number,
  sendMail: CustomerLoginMailSendState,
  withLogin: boolean,
  allocationType: string
}

@Component({
  selector: 'app-customer-login-edit',
  templateUrl: './customer-login-edit.page.html',
  styleUrls: ['./customer-login-edit.page.scss', "../../setting-main.scss"],
})
export class CustomerLoginEditPage implements OnInit {

  public selectedArt: EditArt
  public selectedGroup: EmployeeGroupe

  public isLoading: boolean = true

  public customerLogin: CustomerLogin = {
    employees: [],
    selectedGroup: 0,
    ticketArt: 0,
    sendMail: CustomerLoginMailSendState.OFF,
    withLogin: true,
    allocationType: "group"
  }

  constructor(
    private modalCtrl: ModalController,
    public ticketEditSrv: TicketEditService,
    private feedback: FeedbackService,
    private http: HttpService,
    private general: GeneralService,
    private saveSrv: SaveService.Settings
  ) { }

  async ngOnInit() {

    const result: HttpFunctionResult<CustomerLogin> = await this.http.GET<CustomerLogin>({path: "settings/customerlogin"})
    this.isLoading = false
    if(!result.success) return

    this.customerLogin = result.data
    this.customerLogin.employees = result.data.employees || []
    this.selectedGroup = this.ticketEditSrv.employeeGroupes.find(eg => eg.id == this.customerLogin.selectedGroup)
    this.selectedArt = this.ticketEditSrv.ticketArts.find(ta => ta.id == this.customerLogin.ticketArt)
  }

  public switchEmployee(employee: Employee){
    if(this.customerLogin.employees.includes(employee.id)) this.customerLogin.employees.splice(this.customerLogin.employees.indexOf(employee.id), 1)
    else this.customerLogin.employees.push(employee.id)
  }

  public async selectArt(event: any){
    await this.feedback.openPopover(PopoverPage, event, {type: "TicketArt"}, (result: HttpFunctionResult<EditArt>)=>{
      if(result.success)this.selectedArt = result.data
    })
  }

  public async selectMailSend(event: any){
    await this.feedback.openPopover(PopoverPage, event, {type: "CustomerLoginMailSend"}, async (result: HttpFunctionResult<PopoverListItem>)=>{
      if(result.success){
        this.customerLogin.sendMail = result.data.id
        if(this.customerLogin.sendMail != CustomerLoginMailSendState.OFF) await this.feedback.showMsg(MsgType.Info, "Bitte beachten Sie, dass Sie SMTP-Einstellungen gesetzt haben, damit auch E-Mails an Kunden versendet werden können. Diese können Sie unter Einstellungen -> E-Mail-Einstellungen setzen.")
      }
    })
  }

  public async selectGroup(event: any){
    await this.feedback.openPopover(PopoverPage, event, {type: "employeeGroups"}, (result: HttpFunctionResult<PopoverListItem>)=>{
      if(result.success) this.selectedGroup = this.ticketEditSrv.employeeGroupes.find(eg => eg.id == result.data.id)
    })
  }

  public async save(){
    
    if(!this.selectedArt) return await this.feedback.showError("Bitte geben Sie eine Ticket-Art an.")
    if(!this.selectedGroup && this.customerLogin.allocationType == "group") return await this.feedback.showError("Bitte geben Sie eine Gruppe an.")
    if(this.customerLogin.employees.length == 0 && this.customerLogin.allocationType == "employee") return await this.feedback.showError("Bitte geben Sie mindestens einen Mitarbeiter an.")

    this.customerLogin.selectedGroup = this.selectedGroup?.id || 0
    this.customerLogin.ticketArt = this.selectedArt.id

    await this.feedback.updateLoading("Speichern...")
    const result: HttpFunctionResult<CustomerLogin> = await this.saveSrv.updateCustomerLogin(this.customerLogin)
    await this.feedback.hideLoading()
    if(!result.success) return 
    this.general.webConfig.customerMailSend = this.customerLogin.sendMail
    await this.back()

  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

}
